<template>
	<div class="flex flex-col h-screen">
		<div class="bg-color-5 h-16 flex-none flex justify-between header-section dock-menu" id="header">
			<div class="h-full my-0 py-0 flex flex-row">
				<img class="h-full my-0 py-0" :src="firm.logo_src">
				<div class="flex items-center text-lg font-bold text-color-2 pl-3"><span>{{showName}}</span></div>
			</div>
			<notification :notification="notification" :closeAction="hideNotification" />
			<div class="flex">
				<button type="button" id="login" class="eny-btn-blue px-6 py-0 m-3 text-lg font-bold" @click="loginTraderPortal">{{$t('eny.login_original')}}</button>
				<div class="w-20 my-3 mr-3">
					<ejs-dropdown id='locales' name='locales' :dataSource='locales' :fields='fields' floatLabelType="Auto" :showClearButton="false" cssClass="!border-color-2 "
						:allowCustom="false" v-model:value="locale"></ejs-dropdown>
				</div>
			</div>
		</div>
		<div class="grow">
			<router-view name="public"></router-view>
		</div>
		<div class="flex-none">
			<eny-footer></eny-footer>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import Footer from "./Footer.vue";
import Notification from "../Base/Notification.vue";
import useNotification from "../hooks/useNotification";
import datePickerUtils from '../../syncfusion/datepicker';
import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import { useI18n } from 'vue-i18n'
export default {
	name: "Screen",
	components: {
		'eny-footer': Footer,
		'notification': Notification,
		'ejs-dropdown': DropDownListComponent,
	},
	setup() {
		const { notification, hideNotification } = useNotification();
		const { setLocale } = datePickerUtils();
		const { locale } = useI18n({ useScope: 'global' })
		const fields= { text: 'label', value: 'value' };
		return {
			notification,
			hideNotification,
			fields,
			locale,
			setLocale
		}
	},
	methods: {
		loginTraderPortal: function() {
			window.location.href = '/dashboard';
		}
	},
	computed: {
		...mapGetters('user', ['firm', 'locales']),
		...mapGetters('customer', ['user']),
		showName: function () {
			return this.firm.short_name ?? this.firm?.name;
		} 
	},
	watch: {
		locale(value) {
			localStorage.setItem('lang', value);
			this.setLocale(value)
			if (this.user.kc_user_id) {
				this.user.locale = value
				this.$store.dispatch('user/update_locale', this.user);
			}
		}
	}
}
</script>
